import http from './http'

/**
 * @description 爱办公 后台登录
 */
export const apiOfficeLogin = function (params) {
  return http.post('/api/user/login_third', params)
}

/**
 * @default 获取分类列表
 * @return {AxiosPromise<any>}
 */
export const apiOfficeGetCategoryList = function () {
  return http.post('/api/category/list')
}

export const apiOfficeGetMatList = function (params) {
  return http.post('/api/mat/list', params)
}

export const apiOfficeGetDetail = function (params) {
  return http.post('/api/mat/detail', params)
}

export const apiOfficeGetMatStatistics = function (params) {
  return http.post('/api/mat/statistics', params)
}

export const apiOfficeDownload = function (params) {
  return http.post('/api/mat/download', params)
}
